"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (width) {
    if (width === void 0) { width = 375; }
    if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
        document.documentElement.style.fontSize = (document.documentElement.clientWidth / width) *
            16 + "px";
    }
    else {
        document.documentElement.style.fontSize = (window.innerWidth / width) * 16 + "px";
    }
});
